<template>
  <content-items-edit
    content-type="reports"
    content-type-singular="report"
    content-name="Reports"
    content-name-singular="Report"
  />
</template>

<script>
import ContentItemsEdit from '@/views/content-item/content-items-edit/ContentItemsEdit.vue'

export default {
  components: {
    ContentItemsEdit,
  },
}
</script>

<style scoped>

</style>
